/* LP - Second bag: swap the card image when a colour is chosen. */
(function () {
  function onChange(event) {
    var sel = event.target;
    if (!sel || !sel.matches || !sel.matches('[data-lp-second-variant]')) return;

    var card = sel.closest('.lp-second__card');
    if (!card) return;

    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;

    var img = card.querySelector('[data-lp-second-img]');
    var src = opt.getAttribute('data-image');
    if (img && src) img.src = src;

    var was = card.querySelector('.lp-second__was');
    var price = opt.getAttribute('data-price');
    if (was && price) was.textContent = price;
  }

  document.addEventListener('change', onChange);
})();